module.exports = __webpack_public_path__ + "static/media/il.c36a011d.svg";